const host = 'https://cjb.xahulian.com/'

export default {
  host
}